import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import S3ReaderForm from '../forms/s3-reader-form';
import { s3ReaderValidationSchema } from '../schema/s3Reader.js';

export default function S3ReaderNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Amazon S3 Reader Node Details',
        altText: 'Amazon S3 Reader Node',
        defaultLabel: 'S3 Reader Node',
      }}
    >
      <CommonNode FormComponent={S3ReaderForm} schemaResolver={s3ReaderValidationSchema} />
    </NodeProvider>
  );
}
